// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3k3tG","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2VhjU"};